import React, { useEffect } from "react";
import UserAddressCard from "./UserAddressCard";
import { useAppDispatch } from "../../../State/Store"; // Path to your Store
import { useSelector } from "react-redux";
import { fetchUserAddresses } from "../../../State/customer/addressSlice";
import { CircularProgress } from "@mui/material";

const Address = () => {
    const dispatch = useAppDispatch();
    
    // Select the addresses and loading state from your Redux store
    // Adjust "address" depending on how your reducer is named in your store configuration
    const { addresses, loading } = useSelector((state: any) => state.address);

    useEffect(() => {
        const jwtToken = localStorage.getItem("jwt") || "";
        if (jwtToken) {
            dispatch(fetchUserAddresses(jwtToken));
        }
    }, [dispatch]);

    if (loading) {
        return (
            <div className="flex justify-center items-center py-10">
                <CircularProgress />
            </div>
        );
    }

    return (
        <div className='space-y-3'>
            {addresses && addresses.length > 0 ? (
                addresses.map((item: any) => (
                    <UserAddressCard key={item.id} addressItem={item} />
                ))
            ) : (
                <p className="text-center text-gray-500 py-5">No saved addresses found.</p>
            )}
        </div>
    );
};

export default Address;